import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./firebaseAuth";

const FreeRoute = ({ component: RouteComponent, ...rest }) => {
  const {currentUser} = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={routeProps =>
        !!currentUser ? (
            <Redirect to={"/all-room"} />
        ) : (
            <RouteComponent {...routeProps} />
        )
      }
    />
  );
};


export default FreeRoute